import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { WEEKDAYS } from "../lib/fmt";
import { Block } from "./Common";

const TIMES = [
  ["deadline", "Batas pengisian"],
  ["preReminderTime", "Pengingat sebelum batas (kosong = mati)"],
  ["adminReminderTime", "Rekap harian ke Leader"],
  ["teamReminderTime", "Pengingat pagi ke anggota"],
];

export default function PanelSettings() {
  const [s, setS] = useState(null);
  const [newPin, setNewPin] = useState("");
  const [waToken, setWaToken] = useState("");
  const [newProgram, setNewProgram] = useState("");
  const [waPhone, setWaPhone] = useState("");
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return <Block title="Jadwal & pengaturan"><p className="text-sm">Memuat…</p></Block>;
  const set = (k) => (e) => setS({ ...s, [k]: e.target.value });
  const toggleDay = (d) => setS({ ...s, workDays: s.workDays.includes(d) ? s.workDays.filter((x) => x !== d) : [...s.workDays, d].sort() });
  const save = async (extra = {}) => {
    try {
      const r = await api.put("/settings", { ...s, weeklyRecapDay: Number(s.weeklyRecapDay), editWindowDays: Number(s.editWindowDays), newPanelPin: newPin, waToken, ...extra });
      setS(r.data);
      setNewPin("");
      setWaToken("");
      toast.success("Pengaturan tersimpan");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const addProgram = () => {
    const v = newProgram.trim();
    if (v && !s.programs.some((x) => x.toLowerCase() === v.toLowerCase())) setS({ ...s, programs: [...s.programs, v] });
    setNewProgram("");
  };
  const testWa = async () => {
    try {
      await api.post("/wa/test", { phone: waPhone });
      toast.success("Pesan tes WhatsApp terkirim");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Block title="Jadwal & pengaturan" testid="panel-settings">
      <div className="grid gap-3 sm:grid-cols-2">
        {TIMES.map(([k, l]) => (
          <div key={k}>
            <label className="label" htmlFor={`set-${k}`}>{l}</label>
            <input id={`set-${k}`} data-testid={`settings-${k}`} type="time" className="field" value={s[k] || ""} onChange={set(k)} />
          </div>
        ))}
        <div>
          <label className="label" htmlFor="set-wday">Rekap mingguan — hari</label>
          <select id="set-wday" data-testid="settings-weeklyRecapDay" className="field" value={s.weeklyRecapDay} onChange={set("weeklyRecapDay")}>
            {WEEKDAYS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </div>
        <div>
          <label className="label" htmlFor="set-wtime">Rekap mingguan — jam</label>
          <input id="set-wtime" data-testid="settings-weeklyRecapTime" type="time" className="field" value={s.weeklyRecapTime} onChange={set("weeklyRecapTime")} />
        </div>
      </div>
      <div className="mt-4">
        <span className="label">Hari kerja</span>
        <div className="flex flex-wrap gap-2">
          {WEEKDAYS.map(([v, l]) => (
            <label key={v} className={`inline-flex min-h-[44px] cursor-pointer items-center gap-2 rounded-full border px-3.5 text-sm font-semibold ${s.workDays.includes(v) ? "border-brand bg-brand-tint text-brand-deep" : "border-brand-line"}`}>
              <input data-testid={`settings-workday-${v}`} type="checkbox" className="accent-[#D7191F]" checked={s.workDays.includes(v)} onChange={() => toggleDay(v)} /> {l}
            </label>
          ))}
        </div>
      </div>
      <div className="mt-4 grid gap-3 sm:grid-cols-2">
        <div>
          <label className="label" htmlFor="set-admin">Email admin</label>
          <input id="set-admin" data-testid="settings-adminEmail" type="email" className="field" value={s.adminEmail} onChange={set("adminEmail")} />
        </div>
        <div>
          <label className="label" htmlFor="set-edit">Batas edit (hari)</label>
          <input id="set-edit" data-testid="settings-editWindowDays" type="number" min={0} max={30} className="field" value={s.editWindowDays} onChange={set("editWindowDays")} />
        </div>
        <div>
          <label className="label" htmlFor="set-pin">PIN panel baru</label>
          <input id="set-pin" data-testid="settings-newPanelPin" type="password" inputMode="numeric" maxLength={6} className="field" placeholder="Kosongkan bila tidak diganti"
            value={newPin} onChange={(e) => setNewPin(e.target.value.replace(/\D/g, ""))} />
        </div>
      </div>
      <div className="mt-5 border-t border-brand-line pt-4" data-testid="settings-programs">
        <span className="label">Daftar program</span>
        <div className="flex flex-wrap gap-2">
          {s.programs.map((pg) => (
            <span key={pg} className="inline-flex items-center gap-1 rounded-full bg-brand-tint py-1 pl-3 pr-1 text-sm font-semibold text-brand-deep">
              {pg}
              <button data-testid={`program-remove-${pg}`} onClick={() => setS({ ...s, programs: s.programs.filter((x) => x !== pg) })} aria-label={`Hapus ${pg}`} className="flex h-7 w-7 items-center justify-center rounded-full hover:bg-white">×</button>
            </span>
          ))}
        </div>
        <div className="mt-2 flex gap-2">
          <input data-testid="program-new-input" className="field flex-1" placeholder="Nama program baru" value={newProgram}
            onChange={(e) => setNewProgram(e.target.value)} onKeyDown={(e) => e.key === "Enter" && addProgram()} />
          <button data-testid="program-add-button" onClick={addProgram} className="btn-soft">Tambah</button>
        </div>
      </div>
      <div className="mt-5 border-t border-brand-line pt-4" data-testid="settings-wa">
        <span className="label">Pengingat WhatsApp (Fonnte)</span>
        <label className="mb-3 inline-flex min-h-[44px] cursor-pointer items-center gap-2 text-sm font-semibold">
          <input data-testid="settings-waEnabled" type="checkbox" className="accent-[#D7191F]" checked={!!s.waEnabled} onChange={(e) => setS({ ...s, waEnabled: e.target.checked })} />
          Kirim juga lewat WhatsApp (jadwal sama dengan email)
        </label>
        <input data-testid="settings-waToken" type="password" className="field" value={waToken} onChange={(e) => setWaToken(e.target.value)}
          placeholder={s.waTokenSet ? "Token tersimpan — isi untuk mengganti" : "Token perangkat dari Fonnte"} />
        <div className="mt-2 flex gap-2">
          <input data-testid="wa-test-phone" className="field flex-1" inputMode="tel" placeholder="No WA untuk tes, mis. 0812…" value={waPhone} onChange={(e) => setWaPhone(e.target.value)} />
          <button data-testid="wa-test-button" onClick={testWa} disabled={!s.waTokenSet} className="btn-ghost">Kirim tes</button>
          {s.waTokenSet && <button data-testid="wa-clear-token-button" onClick={() => save({ clearWaToken: true })} className="btn-ghost">Hapus token</button>}
        </div>
        <p className="mt-1 text-xs text-[#7a6667]">Simpan token dulu, lalu kirim tes. Nomor WA tiap anggota diisi di kartu anggota.</p>
      </div>
      <button data-testid="settings-save-button" onClick={() => save()} className="btn-primary mt-5"><Save size={16} /> Simpan pengaturan</button>
    </Block>
  );
}
